import { useTranslation } from '@klv/hooks/useTranslation';

import type { ITranslatedDate } from './types';

const TranslatedDate = ({
  date,
  options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
}: ITranslatedDate) => {
  const { t } = useTranslation();
  const dateObj = date ? new Date(date).toLocaleString(t('langCodes_locale'), options) : date;
  
  return <>{dateObj}</>;
};

export default TranslatedDate;
